import { RouteRegistry } from "QuorumGrassroots/framework/helpers/RouteRegistry"
import { campaignRoutes } from "QuorumGrassroots/pages/campaign/routes"

RouteRegistry.registerMany([...campaignRoutes])
